<template>
 <div>
    <label v-if="!$parent.event.networking || !$parent.event.networking.length"><b>
       No networking rooms in this event.</b>
    </label>
    <b-card-group deck class="net_deck">
      <b-card v-for="nw in $parent.event.networking"
        :title="nw.title" sub-title="" class="net_card"
        >
        <div v-if="session_status($parent.event,nw) == 'ended'"
           style="color:red">
           The networking session has ended.
        </div>
        <div v-if="session_status($parent.event,nw) == 'soon'">
          <div style="color:red"> Starting Soon </div>
          <div v-if="!$parent.registered"
             style="color:red">
             To join, please register in Reception.
          </div>
          <b-button :disabled="!$parent.registered"
             variant="success"
             @click="$parent.goto_room(nw.roomname)">
             Join 
          </b-button>
        </div>
        <div v-if="session_status($parent.event,nw) == 'active'">
          <div v-if="!$parent.registered"
             style="color:red">
             To join, please register in Reception.
          </div>
          <b-button :disabled="!$parent.registered"
             variant="success"
             @click="$parent.goto_room(nw.roomname)">
             Join
          </b-button>
        </div>
      </b-card>
    </b-card-group>
 </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "networking",
  data() {
    return {
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    session_status: utils.session_status,
  },
  computed: {
  },
  beforeDestroy() {
  },
  mounted() {
    let vue = this;
  },
};
</script>

<style lang="scss" scoped>
.net_deck {
  justify-content: center;
  margin-right:0;
  margin-left:0;
}
.net_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
